import type React from "react";

const FilterComponentt: React.FC<{
  searchQuery: string;
  statusQuery: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onClearFilters: () => void;
}> = ({
  searchQuery,
  statusQuery,
  onSearchChange,
  onStatusChange,
  onClearFilters,
}) => {
  return (
    <div className="mb-4 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
      <div className="flex flex-col sm:flex-row gap-2 flex-1">
        <div className="relative flex-1 max-w-md">
          <input
            type="text"
            placeholder="Search by reference..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg "
          />
        </div>
        <div className="relative flex-1 max-w-md">
          <select
            value={statusQuery}
            onChange={(e) => onStatusChange(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg appearance-none bg-white"
          >
            <option value="">Status</option>
            <option value="PENDINGPAYMENT">PENDINGPAYMENT</option>
            <option value="PENDING">PENDING</option>
            <option value="EXPIRED">EXPIRED</option>
            <option value="PAID">PAID</option>
            <option value="CREATED">CREATED</option>
            <option value="INCOMPLETEAMOUNT">INCOMPLETEAMOUNT</option>
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
            <svg
              className="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
        {(searchQuery || statusQuery) && (
          <button
            onClick={onClearFilters}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Clear Filters
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterComponentt;
